import { render, staticRenderFns } from "./Extend.vue?vue&type=template&id=2d5c709c&"
import script from "./Extend.vue?vue&type=script&lang=js&"
export * from "./Extend.vue?vue&type=script&lang=js&"
import style0 from "./Extend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Extend.vue"
export default component.exports